module.exports = __webpack_public_path__ + "img/bb.3620a13a.png";